'use strict';

import { forwardRef } from '@angular/core';
import { RedocComponent, BaseComponent } from '../base';
import JsonPointer from '../../utils/JsonPointer';
import { Tabs, Tab } from '../../shared/components/index';
import { SchemaSample } from '../index';
import { statusCodeType } from '../../utils/helpers';


function isNumeric(n) {
  return (!isNaN(parseFloat(n)) && isFinite(n));
}

function hasExample(response) {
  return ((response.examples && response.examples['application/json']) ||
    response.schema);
}

@RedocComponent({
  selector: 'responses-samples',
  template: `
    <header *ngIf="data.responses.length"> Response samples </header>
    <tabs *ngIf="data.responses.length">
      <tab *ngFor="let response of data.responses" tabTitle="{{response.code}} {{response.description}}"
        [tabStatus]="response.type">
        <schema-sample [pointer]="response.pointer"></schema-sample>
      </tab>
    </tabs>
  `,
  styles: [`
    tab,tabs{display:block}schema-sample{display:block}header{font-family:Montserrat;font-size:0.929em;text-transform:uppercase;margin:0;color:#9fb4be;text-transform:uppercase;font-weight:normal}:host>tabs>ul li{font-family:Montserrat;font-size:0.929em;border-radius:2px;margin:2px 0;padding:2px 8px 3px 8px;color:#9fb4be;line-height:1.25}:host>tabs>ul li:hover{color:#ffffff;background-color:rgba(255,255,255,0.1)}:host>tabs>ul li.active{background-color:white;color:#263238}:host tabs ul{padding-top:10px}
  `],
  directives: [forwardRef( ()=> SchemaSample), Tabs, Tab]
})
export class ResponsesSamples extends BaseComponent {
  constructor(schemaMgr) {
    super(schemaMgr);
  }

  prepareModel() {
    this.data = {};
    this.data.responses = [];

    let responses = this.componentSchema;
    if (!responses) return;

    responses = Object.keys(responses).filter(respCode => {
      // only response-codes and "default"
      return ( isNumeric(respCode) || (respCode === 'default'));
    }).map(respCode => {
      let resp = responses[respCode];
      resp.pointer = JsonPointer.join(this.pointer, respCode);
      if (resp.$ref) {
        let ref = resp.$ref;
        resp = this.schemaMgr.byPointer(resp.$ref);
        resp.pointer = ref;
      }

      resp.code = respCode;
      resp.type = statusCodeType(resp.code);
      return resp;
    })
    .filter(response => hasExample(response));
    this.data.responses = responses;
  }
}
